import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { Header } from "../header/header";
import { SidebarLeft } from "../sidebar/sidebar";
import { Sidebar } from '../../../core/services/sidebar';
import { Language } from '../../../core/services/language';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, SidebarLeft, Header, TranslatePipe, CommonModule],
  templateUrl: './layout.html',
  styleUrl: './layout.css'
})
export class Layout {

  constructor(
    private sidebarService: Sidebar,
    public languageService: Language,
    private router: Router
  ) {

    // Remove no-scroll on every route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        document.body.classList.remove('no-scroll');
      });
  }

  get direction() {
    return this.languageService.direction();
  }

  get isSidebarOpen() {
    return this.sidebarService.isMobileSidebarOpen();
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();

    if (this.isSidebarOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
}